var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        {
          staticStyle: { right: "1em" },
          attrs: { absolute: "", color: "purple darken-3", dark: "" }
        },
        [_c("span", [_vm._v("Customer Application")])]
      ),
      _c(
        "v-list",
        { attrs: { "sub-header": "", "three-line": "" } },
        [
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Name")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(_vm._s(_vm.name || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Category")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(_vm._s(_vm.category.description || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Email")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(_vm._s(_vm.email || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Date Of Birth")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(
                      _vm._s(
                        _vm.dateOfBirth ? _vm.dateOfBirth.dateFormat({}) : "N/A"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Address")]),
                  _c("v-list-item-subtitle", [_vm._v(_vm._s(_vm.address))])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("No Of Heads")]),
                  _c("v-list-item-subtitle", [_vm._v(_vm._s(_vm.noOfHeads))])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Contact Number")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(_vm._s(_vm.contactNumber))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Character Ref.")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(_vm._s(_vm.characterRef || "N/A"))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.customerApplicationCategoryId === 3 ? _c("v-divider") : _vm._e(),
          _vm.customerApplicationCategoryId === 3
            ? _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _vm._v("Hog Pen (length/width/division)")
                      ]),
                      _c("v-list-item-subtitle", [
                        _vm._v(_vm._s(_vm.hogPenDimension))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Created At")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(
                      _vm._s(
                        _vm.createdAt
                          ? _vm.createdAt.dateFormat({
                              hour: "2-digit",
                              minute: "2-digit"
                            })
                          : "N/A"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [_vm._v("Updated At")]),
                  _c("v-list-item-subtitle", [
                    _vm._v(
                      _vm._s(
                        _vm.updatedAt
                          ? _vm.updatedAt.dateFormat({
                              hour: "2-digit",
                              minute: "2-digit"
                            })
                          : "N/A"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }